import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const WaglLogo = () => {
  return (
    <Box sx={{ position: 'relative', display: 'block', alignItems: 'center', justifyContent: 'center', backgroundColor: '#8953EF', color: 'white', height:'16px', width: '16px', borderRadius: '8px' }}>
      <Typography variant="factorA" component="span" className="flipped" sx={{ fontSize: '8px', 
    lineHeight: '16px',
    position: 'absolute',
    top: '1px',
    width: '16px',
    textAlign: 'center',
    marginRight: '1em' }}>
        W
      </Typography>
    </Box>
  );
};

export default WaglLogo;